// Application Configuration
// In development: use relative URLs → React dev server proxy forwards /api to backend (no CORS issues)
// In production: use REACT_APP_API_URL for the deployed API server
const apiBase = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_API_URL || "http://localhost:3002")
  : "";

const config = {
  api: {
    baseURL: apiBase + "/api",
    // Contact form only. The API decides the recipient and builds the email
    // body, so no address or markup is sent from the browser.
    contactEndpoint: apiBase + "/api/email/contact"
  },
  contact: {
    email: "zahid@ezilab.io"
  },
  booking: {
    email: "bookings@tak8.com.au"
  }
};

export default config; 